<template>
	<div class="user-card">
		<div
			v-if="active && view === 'popup'"
			:class="[
				'user-card__info-wrapper',
				{
					'user-card__info-wrapper--opened': active && view === 'popup',
				}
			]"
		>
			<helio-user-card-info
				v-if="view === 'popup'"
				:navigation-links="navigationLinks"
				:user="user"
				:account-settings-link="accountSettingsLink"
				@usercard-close="$emit('close-usercard')"
				@showPersonification="startPersonification"
				@endPersonification="endPersonification"
				@logout="$emit('logout')"
			/>
		</div>

		<portal to="panels">
			<helio-panel
				:active="active && view === 'panel'"
				alignment="right"
				type="overlay"
				class="scroll--small user-card__panel"
				@close="$emit('close-usercard')"
			>
				<template v-slot:content>
					<div
						:tabindex="0"
						@keyup.enter="$emit('close-usercard')"
						@keyup.space="$emit('close-usercard')"
					>
						<helio-icon
							class="user-card__panel-close"
							token="times"
							weight="light"
							@click="$emit('close-usercard')"
						/>
					</div>

					<helio-user-card-info
						:navigation-links="navigationLinks"
						:user="user"
						:account-settings-link="accountSettingsLink"
						@showPersonification="startPersonification"
						@endPersonification="endPersonification"
						@logout="$emit('logout')"
					/>
				</template>
			</helio-panel>
		</portal>
	</div>
</template>

<script>
import UserCardInfo from './user-card-info/UserCardInfo.vue';
import Panel from '../../panel/Panel.vue';
import Icon from '../../icon/Icon.vue';

export default {
	components: {
		'helio-user-card-info': UserCardInfo,
		'helio-panel': Panel,
		'helio-icon': Icon,
	},

	props: {
		active: {
			type: Boolean,
			required: true,
		},

		user: {
			type: Object,
			required: false,
			default: null,
		},

		navigationLinks: {
			type: Array,
			required: true,
			default: null,
		},

		view: {
			type: String,
			required: false,
			default: 'popup',
		},

		accountSettingsLink: {
			type: String,
			required: false,
			default: null,
		},
	},

	mounted() {
		window.addEventListener('keyup', this.checkForEscape);
		window.addEventListener('click', this.closeOutside, true, false);
		window.addEventListener('touchstart', this.closeOutside, true, false);
	},

	beforeDestroy() {
		window.removeEventListener('keyup', this.checkForEscape);
		window.removeEventListener('click', this.closeOutside, true, false);
		window.removeEventListener('touchstart', this.closeOutside, true, false);
	},

	methods: {
		checkForEscape(event) {
			const { keyCode } = event;

			if (keyCode === 27) {
				this.$emit('close-usercard');
			}
		},
		startPersonification() {
			this.$emit('showPersonification');
			this.$emit('close-usercard');
		},

		endPersonification() {
			this.$emit('endPersonification');
			this.$emit('close-usercard');
		},

		disabledTargets(target) {
			return !target.closest('.user-card')
				&& !target.closest('.header__avatar')
				&& !target.closest('.user-card__panel');
		},

		enabledTargets(target) {
			return target.closest('.panel__close');
		},

		closeOutside(event) {
			const { target } = event;

			if (this.active	&& (this.disabledTargets(target) || this.enabledTargets(target))) {
				this.$emit('close-usercard');
			}
		},
	},

};
</script>

<style lang='scss' src='./user-card.scss'/>
